import React, { createContext, useContext } from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';

type ToastType = 'info' | 'success' | 'error';
interface ToastMessage {
  title: string;
  description?: string;
  type?: ToastType;
}

const ToastCtx = createContext<{ show: (msg: ToastMessage) => void } | null>(null);

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const show = ({ title, description, type = 'info' }: ToastMessage) => {
    const fn = type === 'success' ? toast.success : type === 'error' ? toast.error : toast;
    fn(title, { description });
  };
  return (
    <ToastCtx.Provider value={{ show }}>
      {children}
      <SonnerToaster richColors closeButton position="top-right" />
    </ToastCtx.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error('useToast must be used inside ToastProvider');
  return ctx;
}

export default SonnerToaster;

